// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_c0a9b645","message":"_1e653a1d","linkContainer":"_1717d671","link":"_107d8e96"};